import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { routes } from '@data/routes';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { getStateLayerColor, StateLayer } from '@M3/utils/getStayeLayerColor';
import { useLocation } from '@tanstack/react-router';

const NavigationRail = () => {
    const { t } = useTranslation('controls');
    const [, mainRoute] = useLocation().pathname.split('/');

    return (
        <BottomNavigation
            showLabels
            sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
            value={'/' + mainRoute}
        >
            {routes.map(({ name, icon: Icon, path }) => (
                <BottomNavigationAction
                    key={name}
                    label={t(name)}
                    icon={<Icon />}
                    LinkComponent={Link}
                    to={path}
                    value={path}
                    sx={{
                        fontWeight: 'fontWeightMedium',
                        '&.Mui-selected': {
                            fontWeight: 'fontWeightBold',
                            '& > .MuiSvgIcon-root': {
                                px: 1.5,
                                width: 48,
                                borderRadius: 50,
                                background: theme =>
                                    getStateLayerColor(
                                        StateLayer.Focus * 2,
                                        theme.palette.onPrimary.main,
                                        theme.palette.primary.main,
                                    ),
                            },
                        },
                    }}
                />
            ))}
        </BottomNavigation>
    );
};

export default NavigationRail;
